/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Create_Role_CompanyInputs */

const en_admin_user_create_role_company = /** @type {(inputs: Admin_User_Create_Role_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company user`)
};

const de_admin_user_create_role_company = /** @type {(inputs: Admin_User_Create_Role_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmens-Benutzer`)
};

/**
* | output |
* | --- |
* | "Company user" |
*
* @param {Admin_User_Create_Role_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_create_role_company = /** @type {((inputs?: Admin_User_Create_Role_CompanyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Create_Role_CompanyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_create_role_company(inputs)
	return en_admin_user_create_role_company(inputs)
});